export class Credentials {
    cwid?: string;
    userName?: string;
    displayName?: string;
    password?: string;
    token?: string;
}